import React, { useEffect, useState } from "react";
import axios from "axios";

import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import PriceRulesTableRows from "./PriceRulesTableRows";
import { Link, useNavigate, useParams } from "react-router-dom";
import Moment from "moment";
import { Checkbox, Dropdown } from "antd";

const CheckboxGroup = Checkbox.Group;

const ManagePriceRule = (props) => {
  let date = new Date();
  let month = date.getMonth() + 1;
  let endDate =
    date.getFullYear() +
    "-" +
    (month >= 10 ? month : "0" + month) +
    "-" +
    (date.getDate() < 10 ? "0" + date.getDate() : +date.getDate());
  let startDate =
    date.getFullYear() +
    "-" +
    (month >= 10 ? month : "0" + month) +
    "-" +
    (date.getDate() < 10 ? "0" + date.getDate() : +date.getDate());

  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  let navigate = useNavigate();
  const paramObject = useParams();
  const [rowsData, setRowsData] = useState([
    {
      priceruleid: 0,
      quantitytobuy: "",
      flatdiscountperitem: "",
      percentoffperitem: "",
    },
  ]);

  const [formValues, setFormValues] = useState({
    ID: 0,
    RuleName: "",
    StartDate: startDate,
    EndDate: endDate,
    IsActive: true,
    RuleType: 0,
    ItemsToBuy: 0,
    ItemsToGet: 0,
    PercentOff: 0,
    FixedOff: 0,
    SpendAmount: 0,
    CouponCode: "",
    Description: "",
    ShowOnReceipt: 0,
    MixAndMatch: false,
    DisableLoyalty: false,
    TagsIds: "",
    CategoriesIds: "",
    ManufacturersIds: "",
    ItemIds: "",
    ItemKitsIds: "",
    Locations: "",
    NumTimesToApply: 0,
    CouponSpendAmount: 0,
    Coupon: false,
    RequiresCoupon: false,
  });
  const [selectFields, setSelectFields] = useState(false);
  const [quantityToBuy, setQuantityToBuy] = useState(false);
  const [quantityToGet, setQuantityToGet] = useState(false);
  const [spendAmount, setSpendAmount] = useState(false);
  const [discountFields, setDiscountFields] = useState(false);
  const [mixAndMatch, setMixAndMatch] = useState(false);
  const [priceBreaksTable, setPriceBreaksTable] = useState(false);
  const [numTimesToApply, setNumTimesToApply] = useState(false);
  const [tagData, setTagData] = useState([]);
  const [selectedCategory, setselectedCategory] = useState(0);
  const [selectedTags, setSelectedTags] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [manufacturersData, setManufacturersData] = useState([]);
  const [selectedManufacturers, setSelectedManufacturers] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemKitData, setItemKitsData] = useState([]);
  const [selectedItemKit, setSelectedItemKit] = useState([]);
  const [ruleTypeData, setRuleTypeData] = useState([]);
  const [selectedRuleType, setSelectedRuleType] = useState(0);
  const [locationsData, setLocationsData] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCoupon, setShowCoupon] = useState(false);
  const [showCouponOnReceipt, setShowCouponOnReceipt] = useState(false);
  const [UpdateData, setUpdateData] = useState(false);
  const [check, setCheck] = useState([]);
  const [data, setData] = useState([]);
  const [SecondCategories, setSecondCategories] = useState([]);
  const [category, setCategory] = useState([{ ID: 0, CategoryId: "" }]);

  const validationSchema = Yup.object().shape({
    RuleName: Yup.string().required("Rule name is required"),
    RuleType: Yup.string().required("Rule Type is required"),
    MixAndMatch: Yup.bool().required("Mix and Match is required"),
    ShowOnReceipt: Yup.number().notRequired(),
    ItemsToBuy: Yup.number().notRequired(),
    ItemsToGet: Yup.number().notRequired(),
    SpendAmount: Yup.number().notRequired(),
    PercentOff: Yup.number().notRequired(),
    FixedOff: Yup.number().notRequired(),
    NumTimesToApply: Yup.number().notRequired(),
  });

  const handleCheck = (index, evnt, id) => {
    if (id > 0) {
      if (evnt.target.checked) {
        // add the ID to the check state
        setCheck([...check, id]);
      } else {
        // remove the ID from the check state
        setCheck(check.filter((location) => location !== id));
      }
    }
  };

  var isCheck = (location) =>
    check.includes(location.Id) ? "checked-location" : "not-checked-location";

  const addTableRows = () => {
    const rowsInput = {
      priceruleid: 0,
      quantitytobuy: "",
      flatdiscountperitem: "",
      percentoffperitem: "",
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const handleChangeTableRow = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
  };

  const deleteTableRows = (index) => {
    console.log(index);
    const rows = [...rowsData];
    console.log(rows);
    rows.splice(index, 1);
    console.log(rows);
    setRowsData(rows);
  };

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  // fetch all Dropdown Data
  const handleDropdownData = () => {
    setLoading(true);

    // axios
    // .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
    //   headers: {
    //     "Content-Type": "application/json;charset=UTF-8",
    //     Authorization: token,
    //   },
    // })
    // .then((res) => {
    //   setData(res.data.ResponseData);

    //   console.log("categories=====>", res.data.ResponseData);
    //   if (CategorieData != undefined) {
    //     // Binding Category data
    //     let CategorieList = res.data.ResponseData;
    //     // console.log("employeeList =>>", employeeList);
    //     CategorieList.map((selectedCategory) => {
    //       if (selectedCategory.ID == CategorieData) {
    //         setselectedCategory({
    //           label: selectedCategory.Name,
    //           value: selectedCategory.ID,
    //         });
    //       }
    //     });
    //   }
    // });
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/ruletypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setRuleTypeData(res.data.ResponseData);
        setLoading(false);
        return res;
      });
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagData(res.data.ResponseData);
        return res;
      });
    // categories/categoriesdropdown`, {
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {

        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoriesData(res.data.ResponseData);
        return res;
      });
    axios
      .get(
        `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setManufacturersData(res.data.ResponseData);
        return res;
      });
    axios
      .get(`${config.itemsBaseUrl}/items/itemsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setItemsData(res.data.ResponseData);
        return res;
      });
    axios
      .get(`${config.itemKitsBaseUrl}/itemkits/itemkitsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setItemKitsData(res.data.ResponseData);
        console.log("itemkits===>", res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationsData(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    setLoading(false);
  };

  let tagsOption = [];
  const Tags = tagData.map((u, i) => {
    tagsOption[i] = { label: u.Name, value: u.ID };
  });
  let categoriesOption = [];
  const Categories = categoriesData.map((u, i) => {
    categoriesOption[i] = { label: u.Name, value: u.ID };
  });

  let manufacturersOption = [];
  const Manufacturers = manufacturersData.map((u, i) => {
    manufacturersOption[i] = { label: u.Name, value: u.ID };
  });
  let itemOption = [];
  const item = itemsData.map((u, i) => {
    itemOption[i] = { label: u.Name, value: u.ID };
  });
  let itemKitOption = [];
  const ItemKits = itemKitData.map((u, i) => {
    itemKitOption[i] = { label: u.Name, value: u.ID };
  });

  let ruleTypeOption = [];
  const RuleType = ruleTypeData.map((u, i) => {
    ruleTypeOption[i] = { label: u.Name, value: u.Id };
  });

  // let locationOption = [];
  // const Locations = locationsData.map((u, i) => {
  //   locationOption[i] = { label: u.Name, value: u.Id };
  // });

  const handleTagIds = (e) => {
    console.log(selectedTags);
    setSelectedTags(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleCategoriesIds = (e) => {
    setSelectedCategories(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleManufacturersIds = (e) => {
    setSelectedManufacturers(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleItemIds = (e) => {
    setSelectedItems(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleItemKitIds = (e) => {
    setSelectedItemKit(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  const handleLocationsIds = (e) => {
    setSelectedLocations(e);
    console.log("checked = ", e);
    console.log(selectedLocations);
  };

  // Create and Update Data
  const handleSubmit = async (values) => {
    console.log(selectedCategories.toString());
    console.log(paramObject.id);
    const jsonobj = {};
    jsonobj.xmlpricerule = rowsData;

    let jsonstring = JSON.stringify(jsonobj);
    console.log("clicked", jsonstring);
    setLoading(true);
    console.log(
      "categoriesids: selectedCategory.value",
      selectedCategory.value
    );
    axios
      .post(
        `${config.priceRulesBaseUrl}/pricerules/upsert`,
        {
          xmlpricerule: jsonstring,
          id: paramObject.id || 0,
          name: values.RuleName,
          startdate: values.StartDate,
          enddate: values.EndDate,
          isactive: values.IsActive,
          typeid: selectedRuleType.value,
          itemstobuy: values.ItemsToBuy,
          itemstoget: values.ItemsToGet,
          percentoff: values.PercentOff,
          fixedoff: values.FixedOff,
          spendamount: values.SpendAmount,
          numtimestoapply: values.NumTimesToApply,
          couponcode: values.CouponCode,
          description: values.Description,
          showonreceipt: values.ShowOnReceipt,
          couponspendamount: values.CouponSpendAmount,
          mixandmatch: values.MixAndMatch,
          disableloyaltyforrule: values.DisableLoyalty,
          loginuserid: loginUserId,
          tagsids: selectedTags.toString(),
          categoriesids: selectedCategories.toString(),
          // selectedCategory.value,
          manufacturersids: selectedManufacturers.toString(),
          itemsids: selectedItems.toString(),
          itemkitsids: selectedItemKit.toString(),
          locationsids: check.toString(),
        },

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          navigate("/price-rules");

          // window.location.reload();
          toastSuccess(SUCCESS_MESSAGE);
          // handleDropdownData(res.data.ResponseID);
        }
        else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  let rule = [];
  let tags = [];
  let RuleTypeoptions = 0;
  let categories = [];
  let manufacturer = [];
  let Items = [];
  let ItemKit = [];
  let Location = [];



  useEffect(() => {
    // handleRuleTypeDropdown();
    handleDropdownData();
    if (paramObject.id > 0) {
      setLoading(true);
      // console.log(paramObject.id);
      axios
        .get(
          `${config.priceRulesBaseUrl}/pricerules/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const itemdata = res.data.ResponseData.Item;
          const PriceRulesBreaks = res.data.ResponseData.PriceRulesBreaks;
          console.log(res.data.ResponseData);
          setUpdateData(res.data.ResponseData.Item[0]);
          setRowsData(PriceRulesBreaks);


          //for Modifires
          // const locationsids = res.data.ResponseData.locationsData?.map(
          //   (location) => location.locationId.toString()
          // );
          // console.log(locationsids);
          // const newArray = locationsids?.map((str) => parseInt(str, 10)); // array with commaseparet
          // setCheck(newArray);


          formValues.RuleName = res.data.ResponseData.Item.Name;

          axios
            .get(`${config.priceRulesBaseUrl}/pricerules/ruletypedropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const RuleData = res.data.ResponseData;
              setLoading(false);
              //

              const RuleType = RuleData.map((u, i) => {
                rule[i] = { label: u.Name, value: u.Id };
              });

              rule.map((selectRuleType) => {
                if (selectRuleType.value == itemdata[0].Typeid) {
                  setSelectedRuleType(selectRuleType);
                  RuleTypeoptions = selectRuleType;
                }
              });
              handleRuleTypeOptions(RuleTypeoptions);
              ruleTypeOption = rule;
              return res;
            });

          // Bind Tags Data
          axios
            .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const tagData = res.data.ResponseData;
              tagData.map((u, i) => {
                tags[i] = { label: u.Name, value: u.ID };
              });

              // for bind values
              if (itemdata[0].TagId) {
                tags.map((selectTags) => {
                  const splitSelectedTag = itemdata[0].TagId.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedTagnumbers = splitSelectedTag.map(function (
                    str
                  ) {
                    return parseInt(str);
                  });

                  setSelectedTags(splitSelectedTagnumbers);
                });
              }
            });
          // Bind Categories Data


          axios
            .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const CategoriesData = res.data.ResponseData;
              CategoriesData.map((u, i) => {
                categories[i] = { label: u.Name, value: u.ID };
              });

              //   .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
              //     headers: {
              //       "Content-Type": "application/json;charset=UTF-8",
              //       Authorization: token,
              //     },
              //   })
              //   .then((res) => {
              //     setData(res.data.ResponseData);

              //     console.log("categories=====>", res.data.ResponseData);
              //     if (CategorieData != undefined) {
              //       // Binding Category data
              //       let CategorieList = res.data.ResponseData;
              //       // console.log("employeeList =>>", employeeList);
              //       CategorieList.map((selectedCategory) => {
              //         if (selectedCategory.ID == CategorieData) {
              //           setselectedCategory({
              //             label: selectedCategory.Name,
              //             value: selectedCategory.ID,
              //           });
              //         }
              //       });
              //     }
              //   });

              //   // for bind values
              if (itemdata[0].Categoryid) {
                categories.map((selectCategories) => {
                  const splitSelectedCategories =
                    itemdata[0].Categoryid.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedCategorynumbers =
                    splitSelectedCategories.map(function (str) {
                      return parseInt(str);
                    });

                  setSelectedCategories(splitSelectedCategorynumbers);
                });
              }
            });
          // Bind manufacturers Data
          axios
            .get(
              `${config.manufacturerBaseUrl}/manufacturers/manufacturersdropdown`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              const manufacturerData = res.data.ResponseData;
              manufacturerData.map((u, i) => {
                manufacturer[i] = { label: u.Name, value: u.ID };
              });

              // for bind values
              if (itemdata[0].Manufacturerid) {
                manufacturer.map((selectManufacturer) => {
                  const splitSelectedManufacturer =
                    itemdata[0].Manufacturerid.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedManufacturernumbers =
                    splitSelectedManufacturer.map(function (str) {
                      return parseInt(str);
                    });

                  setSelectedManufacturers(splitSelectedManufacturernumbers);
                });
              }
            });
          // Bind items Data
          axios
            .get(`${config.itemsBaseUrl}/items/itemsdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const ItemsData = res.data.ResponseData;
              ItemsData.map((u, i) => {
                Items[i] = { label: u.Name, value: u.ID };
              });

              // for bind values
              if (itemdata[0].Itemid) {
                Items.map((selectItems) => {
                  const splitSelectedItems = itemdata[0].Itemid.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedItemnumbers = splitSelectedItems.map(
                    function (str) {
                      return parseInt(str);
                    }
                  );

                  setSelectedItems(splitSelectedItemnumbers);
                });
              }
            });
          // Bind itemkits Data
          axios
            .get(`${config.itemKitsBaseUrl}/itemkits/itemkitsdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const ItemKitsData = res.data.ResponseData;
              ItemKitsData.map((u, i) => {
                ItemKit[i] = { label: u.Name, value: u.ID };
              });

              // for bind values
              if (itemdata[0].Itemkitid) {
                ItemKit.map((selectItemKits) => {
                  const splitSelectedItemKits =
                    itemdata[0].Itemkitid.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedItemJitnumbers = splitSelectedItemKits.map(
                    function (str) {
                      return parseInt(str);
                    }
                  );

                  setSelectedItemKit(splitSelectedItemJitnumbers.toString());
                });
              }
            });

          // Bind Locations Data
          axios
            .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const LocationData = res.data.ResponseData;
              LocationData.map((u, i) => {
                Location[i] = { label: u.Name, value: u.ID };
              });

              // for bind values
              if (itemdata[0].Locationid) {
                Location.map((selectItemKits) => {
                  const splitSelectedItemKits =
                    itemdata[0].Locationid.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedItemJitnumbers = splitSelectedItemKits.map(
                    function (str) {
                      return parseInt(str);
                    }
                  );

                  setSelectedLocations(splitSelectedItemJitnumbers);
                  // apiData.filter((location) => location.checked)
                });
              }
            });

          // Map All Fields
          itemdata.map((data) => {
            formValues.RuleName = data.Name;
            formValues.StartDate = Moment(data.StartDate).format("yyyy-MM-DD");
            formValues.EndDate = Moment(data.EndDate).format("yyyy-MM-DD");
            formValues.IsActive = data.IsActive === 1 ? true : false;
            formValues.ItemsToBuy = data.Itemstobuy;
            formValues.ItemsToGet = data.Itemstoget;
            formValues.PercentOff = data.Percentoff;
            formValues.FixedOff = data.Fixedoff;
            formValues.SpendAmount = data.Spendamount;
            formValues.NumTimesToApply = data.Numtimestoapply;
            if (data.Couponcode != "") {
              formValues.CouponCode = data.Couponcode;
              formValues.Coupon = true;
              setShowCoupon(true);
              setShowCouponOnReceipt(true);

              formValues.RequiresCoupon = true;
            }

            formValues.Description = data.Description;
            formValues.ShowOnReceipt = data.Showonreceipt;
            formValues.CouponSpendAmount = data.Couponspendamount;
            formValues.MixAndMatch = data.Mixandmatch === 1 ? true : false;
            formValues.DisableLoyalty =
              data.Disableloyaltyforrule === 1 ? true : false;
            formValues.TagsIds = data.TagId;
            formValues.CategoriesIds = data.Categoryid;
            formValues.ManufacturersIds = data.Manufacturerid;
            formValues.ItemIds = data.Itemid;
            formValues.ItemKitsIds = data.Itemkitid;
            formValues.locationsids = data.locationsids;
          });

          setLoading(false);

        })
        .catch((err) => {
          setLoading(false);
        });

    }
  }, []);



  // let ParentCategoryOption = [];
  // const parcategories = data.map((u, i) => {
  //   ParentCategoryOption[i] = { label: u.Name, value: u.ID };
  // });

  //Show Coupon Code
  const handleCouponCode = () => {
    setShowCoupon(!showCoupon);
  };

  const handleCouponOnReceipt = () => {
    setShowCouponOnReceipt(!showCouponOnReceipt);
  };

  //show Hidden Fields on Rule Type Select
  const handleRuleTypeOptions = (event, RuleTypeoptions) => {
    // console.log(RuleTypeoptions);
    if (event.value === 1 || RuleTypeoptions === 1) {
      setSelectFields(true);
      setQuantityToBuy(false);
      setQuantityToGet(false);
      setSpendAmount(false);
      setDiscountFields(true);
      setMixAndMatch(false);
      setPriceBreaksTable(false);
      setNumTimesToApply(false);
    } else if (event.value === 2 || RuleTypeoptions === 2) {
      setSelectFields(true);
      setQuantityToBuy(false);
      setQuantityToGet(false);
      setSpendAmount(false);
      setDiscountFields(true);
      setMixAndMatch(true);
      setPriceBreaksTable(true);
      setNumTimesToApply(false);
    } else if (event.value === 3 || RuleTypeoptions === 3) {
      setSelectFields(true);
      setQuantityToBuy(true);
      setQuantityToGet(true);
      setSpendAmount(false);
      setDiscountFields(false);
      setMixAndMatch(true);
      setPriceBreaksTable(false);
      setNumTimesToApply(false);
    } else if (event.value === 4 || RuleTypeoptions === 4) {
      setSelectFields(true);
      setQuantityToBuy(true);
      setQuantityToGet(true);
      setSpendAmount(false);
      setDiscountFields(true);
      setMixAndMatch(true);
      setPriceBreaksTable(false);
      setNumTimesToApply(false);
    } else if (event.value === 5 || RuleTypeoptions === 5) {
      setSelectFields(false);
      setQuantityToBuy(false);
      setQuantityToGet(false);
      setSpendAmount(true);
      setDiscountFields(true);
      setMixAndMatch(false);
      setPriceBreaksTable(false);
      setNumTimesToApply(false);
    } else {
      setSelectFields(false);
      setQuantityToBuy(false);
      setQuantityToGet(false);
      setSpendAmount(false);
      setDiscountFields(false);
      setMixAndMatch(false);
      setPriceBreaksTable(false);
      setNumTimesToApply(false);
    }
  };

  return (
    <>

      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header"
          style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Price Rule</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/price-rules">Price Rule List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Price Rule</li>
              </ul>
            </div>
          </div>

          {/*Form */}
          <div className="card">
            <div className="card-body">
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ values, errors, touched, handleChange, handleBlur }) => (
                    <Form>
                      <div className="row">
                        <div className="col-12">
                          <Field
                            type="hidden"
                            className="form-control"
                            id="ID"
                            name="ID"
                            value={values.ID}
                          />
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row">
                                <label className="col-form-label col-lg-4">
                                  Rule Type
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="col-lg-8">
                                  {/* ${showMore === false ? '' : 'd-none'} */}
                                  <div>
                                    <Select
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      onChange={(e) => {
                                        setSelectedRuleType(e);
                                        handleRuleTypeOptions(e);
                                      }}
                                      options={ruleTypeOption}
                                      placeholder="Select A Rule Type"
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                      value={selectedRuleType}
                                      id="RuleType"
                                      name="RuleType"
                                      className={` custom-search-select ${errors.RuleType ? "is-invalid" : ""
                                        }`}
                                    />
                                    <div className="invalid-feedback">
                                      {touched.RuleType && errors.RuleType
                                        ? errors.RuleType
                                        : ""}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row mb-3">
                                <label className="col-form-label col-lg-3">
                                  Rule Name
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="col-lg-9">
                                  <Field
                                    type="text"
                                    className={`form-control form-control-sm ${errors.RuleName ? "is-invalid" : ""
                                      }`}
                                    id="RuleName"
                                    name="RuleName"
                                    onChange={handleChange}
                                  />
                                  <div className="invalid-feedback">
                                    {touched.RuleName && errors.RuleName
                                      ? errors.RuleName
                                      : ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <label className="col-form-label col-lg-2 ">
                              Description
                            </label>
                            <div className="col-lg-10">
                              <div className="input-group">
                                <Field
                                  as="textarea"
                                  className="form-control form-control-sm custom-textarea"
                                  rows={3}
                                  id="Description"
                                  name="Description"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row">
                                <label className="col-form-label col-lg-4">
                                  Start Date
                                </label>
                                <div className="col-lg-8">
                                  <div className="input-group">
                                    <Field
                                      type="date"
                                      className="form-control form-control-sm"
                                      id="StartDate"
                                      name="StartDate"
                                      onChange={handleChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row">
                                <label className="col-form-label col-lg-3">
                                  End Date
                                </label>
                                <div className="col-lg-9">
                                  <div className="input-group">
                                    <Field
                                      type="date"
                                      className="form-control form-control-sm"
                                      format="mm/dd/yyyy"
                                      id="EndDate"
                                      name="EndDate"
                                      onChange={handleChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3  mt-3">
                            <label className="col-form-label col-md-2">
                              Locations
                            </label>
                            <div className="col-md-10">
                              {/* <div className="input-group">
                                <CheckboxGroup
                                  options={locationOption}
                                  onChange={handleLocationsIds}
                                  value={selectedLocations}
                                />
                              </div> */}
                              <div className="row">
                                {locationsData.map((location, index) => (
                                  <div
                                    key={location.Id}
                                    className="col-md-3 col-sm-6 mb-3"
                                  >
                                    <div className="form-check col-form-label">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        onChange={(evnt) =>
                                          handleCheck(index, evnt, location.Id)
                                        }
                                        value={location.Id}
                                        defaultChecked={check.includes(
                                          location.Id
                                        )}
                                      />
                                      <label className={isCheck(location.Id)}>
                                        {location.Name}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-form-label col-md-4">
                              Requires Coupon
                            </label>
                            <div className="col-md-8">
                              <div className="input-group">
                                <Field
                                  className="form-check-input"
                                  style={{
                                    width: "1.5em",
                                    height: "1.5em",
                                  }}
                                  type="checkbox"
                                  onChange={handleChange}
                                  onInput={handleCouponCode}
                                  name="RequiresCoupon"
                                  id="RequiresCoupon"
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            className={`${showCoupon === true ? "" : "d-none"}`}
                          >
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                Coupon Code
                              </label>
                              <div className="col-md-8">
                                <div className="input-group">
                                  <Field
                                    className="form-control"
                                    type="text"
                                    onChange={handleChange}
                                    name="CouponCode"
                                    id="CouponCode"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-form-label col-md-4">
                              Print Coupon On Receipt
                            </label>
                            <div className="col-md-8">
                              <div className="input-group">
                                <Field
                                  className="form-check-input"
                                  style={{ width: "1.5em", height: "1.5em" }}
                                  type="checkbox"
                                  onChange={handleChange}
                                  onInput={handleCouponOnReceipt}
                                  name="Coupon"
                                  id="Coupon"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${showCouponOnReceipt === true ? "" : "d-none"
                              } form-group row `}
                          >
                            <label className="col-form-label col-md-4">
                              Spend Amount To Activate On Receipt
                            </label>
                            <div className="col-md-8">
                              <Field
                                className={`form-control ${errors.ShowOnReceipt ? "is-invalid" : ""
                                  }`}
                                type="text"
                                onChange={handleChange}
                                name="ShowOnReceipt"
                                id="ShowOnReceipt"
                              />
                              <div className="invalid-feedback">
                                {touched.ShowOnReceipt && errors.ShowOnReceipt
                                  ? errors.ShowOnReceipt
                                  : ""}
                              </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-form-label col-md-4">
                              Disable Loyalty
                            </label>
                            <div className="col-md-8">
                              <div className="input-group">
                                <Field
                                  className="form-check-input"
                                  style={{ width: "1.5em", height: "1.5em" }}
                                  type="checkbox"
                                  onChange={handleChange}
                                  name="DisableLoyalty"
                                  id="DisableLoyalty"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-form-label col-md-3">
                              Active
                            </label>
                            <div className="col-md-9">
                              <div className="input-group">
                                <Field
                                  className="form-check-input"
                                  style={{ width: "1.5em", height: "1.5em" }}
                                  type="checkbox"
                                  onChange={handleChange}
                                  name="IsActive"
                                  id="IsActive"
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            className={`${selectFields === true ? "" : "d-none"
                              }`}
                            id="select-fields"
                          >
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Select Items
                              </label>
                              <div className="col-md-9">
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <i class="fa fa-list-alt"></i>
                                  </span>

                                  <Select
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isMulti={true}
                                    isClearable={true}
                                    onChange={handleItemIds}
                                    options={itemOption}
                                    placeholder=""
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    value={itemOption.filter((obj) =>
                                      selectedItems.includes(obj.value)
                                    )}
                                    id="ItemIds"
                                    name="ItemIds"
                                    className="custom-search-select w-100"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Select Item Kits
                              </label>
                              <div className="col-md-9">
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <i class="fas fa-luggage-cart"></i>
                                  </span>

                                  <Select
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isMulti={true}
                                    isClearable={true}
                                    onChange={handleItemKitIds}
                                    options={itemKitOption}
                                    placeholder=""
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    value={itemKitOption.filter((obj) =>
                                      selectedItemKit.includes(obj.value)
                                    )}
                                    id="ItemKitsIds"
                                    name="ItemKitsIds"
                                    className="w-100 custom-search-select"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Select Categories
                              </label>
                              <div className="col-md-9">
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <i
                                      className="fa fa-th-list"
                                      data-bs-toggle="tooltip"
                                      title="fa fa-th-list"
                                    ></i>
                                  </span>

                                  <Select
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isMulti={true}
                                    isClearable={true}
                                    onChange={handleCategoriesIds}
                                    options={categoriesOption}
                                    placeholder=""
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    // value={
                                    //   ParentCategoryOption.find(
                                    //     (option) => option.value === selectedCategory.value
                                    //   ) || ""
                                    // }
                                    value={categoriesOption.filter((obj) =>
                                      selectedCategories.includes(obj.value)
                                    )}
                                    id="CategoriesIds"
                                    name="CategoriesIds"
                                    className="w-100 custom-search-select"
                                  />
                                </div>
                              </div>
                            </div>


                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Select Tags
                              </label>
                              <div className="col-md-9">
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <i
                                      className="fa fa-tags"
                                      data-bs-toggle="tooltip"
                                      title="fa fa-tags"
                                    ></i>
                                  </span>

                                  <Select
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isMulti={true}
                                    isClearable={true}
                                    onChange={handleTagIds}
                                    options={tagsOption}
                                    placeholder=""
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    value={tagsOption.filter((obj) =>
                                      selectedTags.includes(obj.value)
                                    )}
                                    id="TagsIds"
                                    name="TagsIds"
                                    className="w-100 custom-search-select"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Select Manufacturers
                              </label>
                              <div className="col-md-9">
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <i
                                      className="fa fa-ambulance"
                                      data-bs-toggle="tooltip"
                                      title="fa fa-ambulance"
                                    ></i>
                                  </span>

                                  <Select
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isMulti={true}
                                    isClearable={true}
                                    onChange={handleManufacturersIds}
                                    options={manufacturersOption}
                                    placeholder=""
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    value={manufacturersOption.filter((obj) =>
                                      selectedManufacturers.includes(obj.value)
                                    )}
                                    id="ManufacturersIds"
                                    name="ManufacturersIds"
                                    className="w-100 custom-search-select"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`row ${quantityToBuy === true ? "" : "d-none"
                              }`}
                            id="quantityToBuy"
                          >
                            <label className="col-form-label col-lg-3">
                              Quantity To Buy
                            </label>
                            <div className="col-lg-9">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${errors.ItemsToBuy ? "is-invalid" : ""
                                  }`}
                                id="ItemsToBuy"
                                name="ItemsToBuy"
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.ItemsToBuy && errors.ItemsToBuy
                                  ? errors.ItemsToBuy
                                  : ""}
                              </div>
                            </div>
                          </div>
                          <div
                            className={`row ${quantityToBuy === true ? "" : "d-none"
                              }`}
                            id="quantityToGet"
                          >
                            <label className="col-form-label col-lg-3">
                              Quantity To Get
                            </label>
                            <div className="col-lg-9">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${errors.ItemsToGet ? "is-invalid" : ""
                                  }`}
                                id="ItemsToGet"
                                name="ItemsToGet"
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.ItemsToGet && errors.ItemsToGet
                                  ? errors.ItemsToGet
                                  : ""}
                              </div>
                            </div>
                          </div>
                          <div
                            className={`row ${spendAmount === true ? "" : "d-none"
                              }`}
                            id="spendAmount"
                          >
                            <label className="col-form-label col-lg-3">
                              Spend Amount
                            </label>
                            <div className="col-lg-9">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${errors.SpendAmount ? "is-invalid" : ""
                                  }`}
                                id="SpendAmount"
                                name="SpendAmount"
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.SpendAmount && errors.SpendAmount
                                  ? errors.SpendAmount
                                  : ""}
                              </div>
                            </div>
                          </div>
                          <div
                            className={`discount_fields ${discountFields === true ? "" : "d-none"
                              }`}
                            id="discountFields"
                          >
                            <div className="row">
                              <label className="col-form-label col-lg-3">
                                Percent Off
                              </label>
                              <div className="col-lg-9">
                                <Field
                                  type="text"
                                  className={`form-control form-control-sm ${errors.PercentOff ? "is-invalid" : ""
                                    }`}
                                  id="PercentOff"
                                  name="PercentOff"
                                  onChange={handleChange}
                                />
                                <div className="invalid-feedback">
                                  {touched.PercentOff && errors.PercentOff
                                    ? errors.PercentOff
                                    : ""}
                                </div>
                              </div>
                            </div>
                            <div className="row m-2">
                              <p className="text-center p-lg">OR</p>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-lg-3">
                                Fixed Off
                              </label>
                              <div className="col-lg-9">
                                <Field
                                  type="text"
                                  className={`form-control form-control-sm ${errors.FixedOff ? "is-invalid" : ""
                                    }`}
                                  id="FixedOff"
                                  name="FixedOff"
                                  onChange={handleChange}
                                />
                                <div className="invalid-feedback">
                                  {touched.FixedOff && errors.FixedOff
                                    ? errors.FixedOff
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`form-group row ${mixAndMatch === true ? "" : "d-none"
                              }`}
                            id="mixAndMatch"
                          >
                            <label className="col-form-label col-md-3">
                              Mix And Match
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9">
                              <div className="input-group">
                                <Field
                                  className={`form-check-input ${errors.MixAndMatch ? "is-invalid" : ""
                                    }`}
                                  style={{ width: "1.5em", height: "1.5em" }}
                                  type="checkbox"
                                  onChange={handleChange}
                                  name="MixAndMatch"
                                  id="MixAndMatch"
                                />
                                <div className="invalid-feedback">
                                  {touched.MixAndMatch && errors.MixAndMatch
                                    ? errors.MixAndMatch
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${priceBreaksTable === true ? "" : "d-none"
                              }`}
                            id="priceBreaksTable"
                          >
                            <div className="form-group row">
                              <label className="col-form-label col-lg-3">
                                Price Breaks
                              </label>
                              <div className="col-lg-9">
                                <table className="table table-bordered text-center">
                                  <thead>
                                    <tr>
                                      <th width="30%">Quantity to Buy</th>
                                      <th width="30%">
                                        Flat Discount Per Item
                                      </th>
                                      <th width="30%">Percent Off Per Item</th>
                                      <th width="10%">Delete</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <PriceRulesTableRows
                                      rowsData={rowsData}
                                      deleteTableRows={deleteTableRows}
                                      handleChange={handleChangeTableRow}
                                    />
                                  </tbody>
                                </table>
                                <button
                                  type="button"
                                  // className="btn btn-secondary  btn-sm pull-left mt-3"
                                className="btn btn-secondary  btn-sm pull-left mt-3"
                                  onClick={addTableRows}
                                >
                                  <i className="fa fa-plus fa-sm" /> Add Item
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`row ${numTimesToApply === true ? "" : "d-none"
                              }`}
                            id="NumTimesToApply"
                          >
                            <label className="col-form-label col-lg-3">
                              Maximum Allowed Per Sale
                            </label>
                            <div className="col-lg-9">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${errors.NumTimesToApply ? "is-invalid" : ""
                                  }`}
                                name="NumTimesToApply"
                                onChange={handleChange}
                              />
                              <div className="invalid-feedback">
                                {touched.NumTimesToApply &&
                                  errors.NumTimesToApply
                                  ? errors.NumTimesToApply
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary btn-md me-1 pull-right"
                        >
                          Submit
                        </button>
                        <Link
                          to="/price-rules"
                          className="btn btn-sm btn-dark btn-md me-1 pull-right"
                        >
                          Cancel
                        </Link>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
          {/* /Form */}
        </div>
      </div>
    </>
  );
};

export default ManagePriceRule;
